<span mat-dialog-title class="title-medium on-surface-text">
  Join requests
</span>

<div mat-dialog-content>
  <mat-action-list disableRipple>
    @for (joinRequest of $joinRequests(); track joinRequest.resourceName) {
      <button mat-list-item (click)="navigateToProfile(joinRequest)">
        <user-avatar
          matListItemAvatar
          class="user-avatar"
          [userResourceName]="joinRequest.resourceName"
        >
        </user-avatar>
        <div matListItemTitle>{{ joinRequest.displayName }}</div>
        <button
          mat-icon-button
          matListItemMeta
          class="error-button"
          (click)="rejectJoinRequest(joinRequest, $event)"
        >
          <mat-icon>close</mat-icon>
        </button>
        <button
          mat-icon-button
          matListItemMeta
          class="primary"
          (click)="acceptJoinRequest(joinRequest, $event)"
        >
          <mat-icon class="on-primary-text">check</mat-icon>
        </button>
      </button>
    }
  </mat-action-list>
</div>
